import { render, staticRenderFns } from "./credit.vue?vue&type=template&id=095201a6"
import script from "./credit.vue?vue&type=script&lang=ts"
export * from "./credit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports